import { render, staticRenderFns } from "./CentrosFormulario.vue?vue&type=template&id=6507cdd2&"
import script from "./CentrosFormulario.vue?vue&type=script&lang=ts&"
export * from "./CentrosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports